import type { ReactElement, ReactNode } from 'react';
import { Box, Group, Text, ThemeIcon } from '@mantine/core';
import { SurfaceCard } from '@/design/SurfaceCard';

/**
 * Shared visual frame for a custom onboarding step: a centered brand card with
 * an icon, title, and description above the step's content. Keeps the team /
 * payment steps consistent with the rest of the wizard.
 */
export function StepShell({
    icon,
    title,
    description,
    children,
}: {
    icon: ReactNode;
    title: string;
    description: string;
    children: ReactNode;
}): ReactElement {
    return (
        <Box maw={520} mx="auto">
            <SurfaceCard>
                <Group gap="sm" align="flex-start" wrap="nowrap">
                    <ThemeIcon size={40} radius="md" variant="light" color="brand">
                        {icon}
                    </ThemeIcon>
                    <Box style={{ flex: 1, minWidth: 0 }}>
                        <Text fw={600} size="md">{title}</Text>
                        <Text size="sm" c="dimmed">{description}</Text>
                    </Box>
                </Group>
                <Box mt="lg">{children}</Box>
            </SurfaceCard>
        </Box>
    );
}
